import type { CSSProperties } from 'react';
import type { ResponsiveProperty } from '../../../utils/responsive';
import { lengthValue, resolveResponsive } from '../../../utils/responsive';
import type { SpacingTypographyProps } from './spacingTypographyHelper';

export interface TypographyProps {
  textAlign?: ResponsiveProperty<CSSProperties['textAlign']>;
  opacity?: CSSProperties['opacity'];
  textTransform?: CSSProperties['textTransform'];
  textDecoration?: CSSProperties['textDecoration'];
  fontWeight?: CSSProperties['fontWeight'];
  whiteSpace?: CSSProperties['whiteSpace'];
  lineHeight?: CSSProperties['lineHeight'];
  lineBreak?: CSSProperties['lineBreak'];
  fontStyle?: CSSProperties['fontStyle'];
}

export const typographyInline = (props: TypographyProps): CSSProperties => {
  const style: CSSProperties = {};
  const set = (key: keyof CSSProperties, value: unknown) => {
    if (value !== undefined) (style as Record<string, unknown>)[key] = value;
  };
  set('textAlign', resolveResponsive(props.textAlign));
  set('opacity', props.opacity);
  set('textTransform', props.textTransform);
  set('textDecoration', props.textDecoration);
  set('fontWeight', props.fontWeight);
  set('whiteSpace', props.whiteSpace);
  set('lineHeight', props.lineHeight);
  set('lineBreak', props.lineBreak);
  set('fontStyle', props.fontStyle);
  return style;
};

export const typographyStyle = (
  token: CSSProperties,
  props: TypographyProps & SpacingTypographyProps
): CSSProperties => {
  const { marginTop, marginBottom, ...rest } = token;
  return {
    ...rest,
    ...typographyInline(props),
    ['--typo-mt' as string]: lengthValue(
      (props.marginTop ?? marginTop) as number | string | undefined
    ),
    ['--typo-mb' as string]: lengthValue(
      (props.marginBottom ?? marginBottom) as number | string | undefined
    ),
  };
};
